import { useEffect, useState } from "react";
import { Card, Spinner, Table, Badge } from "flowbite-react";
import { paymentServices } from "../services/paymentServices";

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    loadOrders();
  }, []);

  const loadOrders = async () => {
    try {
      const data = await paymentServices();
      setOrders(data);
    } catch (err) {
      setError("Failed to load orders");
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case "CAPTURED":
        return <Badge color="success">Captured</Badge>;
      case "FAILED":
        return <Badge color="failure">Failed</Badge>;
      case "PENDING":
        return <Badge color="warning">Pending</Badge>;
      default:
        return <Badge color="gray">Unknown</Badge>;
    }
  };

  // ⏳ Loading
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner size="xl" />
      </div>
    );
  }

  // ❌ Error
  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center text-red-600">
        {error}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <Card>
        <h1 className="text-2xl font-bold mb-4">📦 FitMeal Orders</h1>

        <div className="overflow-x-auto">
          <Table hoverable>
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Plan</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Created At</th>
              </tr>
            </thead>

            <tbody className="divide-y">
              {orders.map((order) => (
                <tr key={order.razorpayOrderId}>
                  <td className="font-mono text-xs">{order.razorpayOrderId}</td>
                  <td>{order.name}</td>
                  <td>{order.email}</td>
                  <td>{order.phone}</td>
                  <td>{order.planCode}</td>
                  <td>₹{order.amount}</td>
                  <td>{getStatusBadge(order.paymentStatus)}</td>
                  <td>{new Date(order.createdAt).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card>
    </div>
  );
}
